<template>
  <div class="chat-relative" v-if="!isOnload">
    <div class="doc-chat-top">
      <div class="top-name">
        <h2>{{toName}}</h2>
        <div class="img-block">
          <img v-if="userType == '01'" class="img-doc" src="../assets/images/icon-doc-detail.png" @click="goDoctorInfo">
          <!-- <img v-if="userType == '03'" class="img-profile" src="../assets/images/icon-patient-profile.png"> -->
          <img v-if="recordStatus === '03' && autoTime=='0'" @click="endChatAsk" class="img-end"
               src="../assets/images/icon-end-inquiry.png">
        </div>

      </div>
      <div class="top-text" v-if="recordStatus">
        <span class="text-left">{{consultTypeObj[consultType]}}</span>
        <span class="text-right" v-if="recordStatus === '01' || recordStatus === '02'">待回复 已等待<span class="time">{{timeStr}}</span></span>
        <span class="text-right" v-else-if="recordStatus === '03' && autoTime=='0'"><span class="time">{{timeStr}}</span>后咨询结束</span>
        <span class="text-right" v-else-if="recordStatus === '03' && autoTime!='0'">待确认</span>
        <span class="text-right" v-else-if="recordStatus === '99'">免费咨询</span>
        <span class="text-right" v-else-if="recordStatus === '04' || recordStatus === '08'">已完成</span>
        <span class="text-right" v-else>已取消</span>
       <!-- <span class="text-right" @click="mstartVoice">录用</span>
        <span class="text-right" @click="mstopVoice">停止</span>-->
      </div>
    </div>
    <div class="chat-wrap doc-chat-wrap" :class="{'showtool':toolShow,'toolnone':autoTime>0}" id="chat-wrap" @click="closeBar">
      <chatItem
        v-for="(msg, index) in msglist"
        type="session"
        :rawMsg="msg"
        :isRobot="isRobot"
        :userInfos="userInfos"
        :myInfo="myInfo"
        :key="(msg.idClient || index)"
        :isHistory='isHistory'
        :userType='userType'
        :orderNo="orderNo"
        :doctorAvatar="doctorImg"
        :doctorSex="doctorSex"
        :userSex="userSex"
        :autoTime="autoTime"
        :endAskTime="endAskTime"
        @msg-loaded="msgLoaded"
        @end-chat="endChat"
        @continue-chat="continueChat"
        @custom-fun="customFun"
        @show-img="showFullImg"
        @revocate-msg="revocateMsg"
        @re-edit="reEdit"
      ></chatItem>
    </div>
    <div class="chat-wrap-footer flex-col-c" v-if="(recordStatus === '03' || recordStatus === '99') && autoTime == '0'">
      <!-- <div class="chat-wrap-footer flex-col-c"> -->
      <div class="input-container flex-sb-c">
        <!-- <span class="chat-voice" @click="showVoice" v-if="!voiceShow"></span> -->
        <span class="chat-keyboard" @click="showKeyboard" v-if="voiceShow"></span>
        <span class="chat-voice-btn" v-if="voiceShow">
          <span :class="{'active':recording}" @touchstart.prevent="toRecord" v-touch:swipeup='cancelRecord'
                @touchend.prevent="sendRecordMsg">{{recording?'松开结束':'按住说话'}}</span>
        </span>
        <div class="text-container chat-input" v-if="!voiceShow">
          <!-- <textarea v-model="msgToSent" @focusin="textFocus" @blur="textBlur"></textarea> -->
          <div contenteditable ref="textareaElement" class="textarea" @focusin="textFocus" @blur="textBlur" @input="changeVal"></div>
        </div>
        <span class="chat-emoji" @click="showEmoji"></span>
        <span class="chat-add" @click="showTool" v-if="!msgToSent || voiceShow"></span>
        <span class="chat-send" @click="sendTextMsg" v-else>发送</span>
      </div>
      <emoji @emoji-click="emojiCLick" @emoji-send="emojiSend" v-if="emojiFlag"></emoji>
      <div
        class="chat-wrap-tools"
        v-show="toolShow"
        @click.stop
      >
        <div class="chat-tool-container">
          <div class="chat-tool-cell">
            <span class="chat-tool">
              <img src="../assets/images/tp.png" alt>
            </span>
            <span class="chat-label">图片</span>
            <input type="file" ref="imgToSent" accept="image/*" @change="sendFileMsg('imgToSent')">
          </div>
          <!-- <div class="chat-tool-cell">
            <span class="chat-tool">
              <img src="../assets/images/pz.png" alt>
            </span>
            <span class="chat-label">视频</span>
            <input type="file" ref="videoToSent" accept="video/*" @change="sendFileMsg('videoToSent')">
          </div> -->
          <!-- <div class="chat-tool-cell">
            <span class="chat-tool" @click="audioNim">
              <img src="../assets/images/pz.png" alt>
            </span>
            <span class="chat-label">语音通话</span>
          </div>
          <div class="chat-tool-cell">
            <span class="chat-tool" @click="videoNim">
              <img src="../assets/images/pz.png" alt>
            </span>
            <span class="chat-label">视频通话</span>
          </div> -->
          <div class="chat-tool-cell" v-for="(item, index) in platList" :key="index" @click="platLink(item.utl)">
            <span class="chat-tool">
              <img src="../assets/images/mbxf.png" alt>
            </span>
            <span class="chat-label">{{item.name}}</span>
          </div>
        </div>
        <!-- <div class="chat-tool-container">
          <div class="chat-tool-cell">
            <span class="chat-tool" @click="audioNim">
              <img src="../assets/images/pz.png" alt>
            </span>
            <span class="chat-label">语音通话</span>
          </div>
          <div class="chat-tool-cell">
            <span class="chat-tool" @click="videoNim">
              <img src="../assets/images/pz.png" alt>
            </span>
            <span class="chat-label">视频通话</span>
          </div>
          <div class="chat-tool-cell">
             <span class="chat-tool">
            <img src="../assets/images/hzda.png" alt>
          </span>
            <span class="chat-label">患者档案</span>
          </div>

          <span class="chat-tool-cell"></span>
        </div> -->
      </div>
    </div>

    <div class="chat-yorn" v-if="userType=='03' && (recordStatus === '01' || recordStatus === '02')">
      <!-- <p>是否接诊该患者？</p> -->
      <div class="yorn-btn">
        <a class="no" @click="unAccepts">取消订单</a>
        <a class="yes" @click="accepts">回复患者</a>
      </div>
    </div>

    <div class="chat-yorn" v-if="userType=='01' && (recordStatus === '01' || recordStatus === '02')">
      <!-- <p>是否接诊该患者？</p> -->
      <div class="yorn-btn">
        <a class="no" @click="cancelAsk = true">取消咨询</a>
      </div>
    </div>

    <div class="cancel-bar canceled-bar"
         v-if="userType=='01' && consultType != '06' && recordStatus != '01' && recordStatus != '02' && recordStatus != '03' && recordStatus != '99'">
      <div class="canceled-text">{{consultTypeObj2[consultType]}}：<span>¥{{consultPrice}}</span></div>
      <a @click="replay">再次咨询</a>
    </div>

    <div class="confirm-wrap" v-if="cancelAsk">
      <div class="content-container wait-container">
        <div class="content-title orange">医生暂未回复</div>
        <div class="content-detail">十分抱歉，医生还未回复，是否确定取消该咨询订单？</div>
        <div class="choose-container">
          <div class="btn-item btn-confirm"><span @click="cancelAsk = false">继续等待</span></div>
          <div class="btn-item btn-cancel"><span @click="cancelOrder">取消咨询</span></div>
        </div>
      </div>
    </div>

    <div class="confirm-wrap" v-if="endAsk">
      <div class="content-container wait-container">
        <div class="content-title orange">我要结束咨询</div>
        <div class="content-detail">结束咨询后，如还需要咨询，您需要重新提交咨询订单。</div>
        <div class="choose-container">
          <div class="btn-item btn-confirm"><span @click="endAsk = false">继续咨询</span></div>
          <div class="btn-item btn-cancel"><span @click="endChat">结束咨询</span></div>
        </div>
      </div>
    </div>

    <!-- component -->
    <div class="images" v-viewer style="display: none;">
      <img v-for="src in images" :src="src" :key="src">
    </div>

    <div class="touch-loop-wrap" :class="{'show':touchLoopShow}">
      <div class="mask" @click="touchLoopShow=false"></div>
      <div class="operation-list">
        <h1>是否撤回该条消息</h1>
        <ul>
          <li class="confirm" @click="revocateMsgConfirm">确定</li>
          <li @click="touchLoopShow=false">取消</li>
        </ul>
      </div>

    </div>

  </div>
</template>

<script>
  import cookie from 'js-cookie';
  import {mapGetters} from "vuex";
  import util from '@/utils'
  import pageUtil from '@/utils/page'
  import Recorder from '@/plugins/recorder.js'
  import chatItem from './common/chatItem'
  import emoji from './common/emoji'

  import * as $services from '@/services/index'

  export default {
    data() {
      const data = {
        images: [],
        defaultSeconds: 1 * 3600,
        msgToSent: "",
        overTip:
          "您好，为了不耽误您的时间，我这边已经停止咨询，祝您身体健康，万事如意。",
        toolShow: false,
        top: 0,
        pageIndex: 1,
        px2repx: 1,
        timer: null,
        isAll: false,
        // currentHeight: 0,
        msgLoadedTimer: null,
        isHistory: false,
        type: "session",
        voiceShow: false,
        recording: false,
        isLongPress: false,
        recorderManager: null, // 微信录音管理对象
        emojiFlag: false,
        currPagePos: 0,
        isMore: false,
        audioContext: null,
        recordDisable: false,
        orderNo: "",
        cutTime: 0,
        timeStr: "",
        lastMsgLength: 0,
        userId: "",
        deptId:"",
        doctorId: "",
        userType: "",
        toName: "",
        createTime:"",
        consultType: "",
        cancelAsk: false,
        evaluateAsk:false,
        endAsk: false,
        platList: [],
        consultPrice: "0.00",
        doctorImg:"",
        doctorSex:"1",
        userSex:"1",
        autoTime:0,
        endAskTime:"",
        touchLoopShow:false,
        reMsg:"",
        consultTypeObj: {
          "01": "在线咨询-图文咨询",
          "02": "在线咨询-视频咨询",
          "03": "在线复诊-图文咨询",
          "04": "在线复诊-视频咨询",
          "05": "免费咨询",
          "06": "续方申请"
        },
        consultTypeObj2: {
          "01": "图文咨询",
          "02": "视频咨询",
          "03": "图文复诊",
          "04": "视频复诊",
          "05": "免费咨询",
          "06": "续方申请"
        },
        isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        isOnload: true
      }
      try {
        data.audioContext = new window.AudioContext
      } catch (e) {
        data.recordDisable = true
        console.error(e)
      }
      return data
    },
    components: {
      chatItem,
      emoji
    },
    computed: {
      ...mapGetters([
        "userInfo"
      ]),
      hours() {
        return parseInt(this.defaultSeconds / 3600);
      },
      minutes() {
        return parseInt((this.defaultSeconds % 3600) / 60);
      },
      imgUrl() {
        return this.globalData.IMUrl + this.globalData.IMApis.IMReadImage;
      },
      recordStatus() {
        return this.$store.state.nimSDK.recordStatus
      },
      currSessionId() {
        return this.$store.state.nimSDK.currSessionId
      },
      robotInfos() {
        return this.$store.state.nimSDK.robotInfos
      },
      userInfos() {
        return this.$store.state.nimSDK.userInfos
      },
      myInfo() {
        return this.$store.state.nimSDK.myInfo
      },
      scene() {
        return this.currSessionId ? util.parseSession(this.currSessionId).scene : ""
      },
      to() {
        return this.currSessionId ? util.parseSession(this.currSessionId).to : ""
      },
      sessionAvatar() {
        let sessionId = this.currSessionId
        let user = null
        if (/^p2p-/.test(sessionId)) {
          user = sessionId.replace(/^p2p-/, '')
          let userInfo = this.userInfos[user] || {}
          return userInfo.avatar
        }
      },
      sessionName() {
        let sessionId = this.currSessionId
        let user = null
        if (/^p2p-/.test(sessionId)) {
          user = sessionId.replace(/^p2p-/, '')
          if (user === this.$store.state.nimSDK.userUID) {
            return '我的手机'
          } else if (this.isRobot) {
            return this.robotInfos[user].nick
          } else {
            let userInfo = this.userInfos[user] || {}
            return util.getFriendAlias(userInfo)
          }
        } else if (/^team-/.test(sessionId)) {
          if (this.teamInfo) {
            // teamInfo中的人数为初始获取的值，在人员增减后不会及时更新，而teamMembers在人员增减后同步维护的人员信息
            var members = this.$store.state.nimSDK.teamMembers && this.$store.state.nimSDK.teamMembers[this.teamInfo.teamId]
            var memberCount = members && members.length
            return this.teamInfo.name + (memberCount ? `(${memberCount})` : '')
          } else {
            return '群'
          }
        }
      },
      // 判断是否是机器人
      isRobot() {
        let sessionId = this.currSessionId
        let user = null
        if (/^p2p-/.test(sessionId)) {
          user = sessionId.replace(/^p2p-/, '')
          if (this.robotInfos[user]) {
            return true
          }
        }
        return false
      },
      msglist() {
        let msgs = this.$store.state.nimSDK.currSessionMsgs
        for (var i in msgs) {
          if (!msgs[i].fromNick) {
            msgs[i].fromNick = "";
          }
          if (!msgs[i].fromClientType) {
            msgs[i].fromClientType = "";
          }
          if (!msgs[i].fromDeviceId) {
            msgs[i].fromDeviceId = "";
          }
        }
        return msgs
      },
      canLoadMore() {
        return !this.$store.state.nimSDK.noMoreHistoryMsgs
      }
    },
    updated() {
      if (this.isMore && this.lastMsgLength != this.msglist.length) {
        let tempPagePos = pageUtil.getChatListHeight("chat-wrap");
        pageUtil.scrollChatListDown("chat-wrap", tempPagePos - this.currPagePos);
        this.currPagePos = tempPagePos;
        this.lastMsgLength = this.msglist.length;
      }
    },

    created: function () {
      this.userType = this.$route.query.userType;
      this.orderNo = this.$route.query.orderNo;
      this.createTime = new Date();
      if(this.isIOSweixin()){
        this.initJSSDK();
      }
      this.getPlatImResourceList();
    },
    mounted() {
      // if(this.isIOS){
      //   document.body.style.height = window.innerHeight + "px";
      //   document.documentElement.style.height = window.innerHeight + "px";
      // }
      this.fromIm = JSON.parse(window.localStorage.getItem("fromIm"));
      cookie.set('uid', this.fromIm.accid)
      cookie.set('sdktoken', this.fromIm.token)
      if (!this.$store.state.nimSDK.nim) {
        this.$store.dispatch('connect');
      }
      this.getConsultInfo();
      // setTimeout(()=>{
      //   this.loadMore();
      // },1000)
    },
    methods: {
      cutTimer() {
        this.timer = setInterval(() => {
          this.cutTime--;
          this.timeFormat();
          if (this.cutTime <= 0) {
            if (this.recordStatus == "03") {
              this.$store.dispatch('setRecordStatus', "08");
            }
            clearInterval(this.timer)
          }
        }, 1000)
      },
      addTimer(total) {
        this.timer = setInterval(() => {
          this.cutTime++;
          this.timeFormat();
          if (this.cutTime >= total) {
            if (this.recordStatus == "01" || this.recordStatus == "02") {
              this.$store.dispatch('setRecordStatus', "07");
            }
            clearInterval(this.timer)
          }
        }, 1000)
      },
      timeFormat() {
        var hh = parseInt(this.cutTime / 3600);
        var mm = parseInt(this.cutTime / 60) % 60;
        var ss = this.cutTime % 60;
        this.timeStr = (hh > 0 ? hh + "时" : "") + (hh > 0 || mm > 0 ? mm + "分" : "") + ss + "秒"
      },
      closeBar() {
        this.toolShow = false;
        this.emojiFlag = false;
      },
      msgLoaded() {
        if (!this.isMore) {
          this.currPagePos = pageUtil.getChatListHeight("chat-wrap");
          pageUtil.scrollChatListDown("chat-wrap");
        }
      },
      getHistoryMsgs() {
        if (this.canLoadMore) {
          this.$store.dispatch('getHistoryMsgs', {
            scene: this.scene,
            to: this.to
          })
        }
      },
      loadMore() {
        let dom = document.getElementById('chat-wrap');
        dom.onscroll = () => {
          if (pageUtil.getChatListScroll('chat-wrap') == 0) {
            this.isMore = true;
            this.getHistoryMsgs()
          }
        }
      },
      showEmoji() {
        this.voiceShow = false;
        this.emojiFlag = this.emojiFlag ? false : true;
        this.closeTool();
      },
      closeTool() {
        this.toolShow = false;
      },
      showTool() {
        this.watchOper();
        this.emojiFlag = false;
        this.toolShow = true;
        setTimeout(function(){
          pageUtil.scrollChatListDown("chat-wrap");
        },50)
      },
      checkContinue() {
        console.log("敬请期待")
        this.$toast('敬请期待');
      },
      checkForm() {
        console.log("敬请期待")
        this.$toast('敬请期待');
      },
      toRecord() {
        let self = this;
        this.watchOper();
        if(self.isIOSweixin()){
          //调用jssdk录音
          if (self.recording) {
            console.log('recording is true');
            return false;
          }
          self.mstartVoice();
        }else {
          self.toRecordCount++
          if (window.stopPlayAudio) {
            window.stopPlayAudio()
          }
          if (location.protocol === 'http:') {
            self.$toast('请使用https协议');
            return
          }
          if (self.recording) {
            return
          }
          if (self.toRecordCount > 1 && !self.recorder) {
            self.recordDisable = true
          }
          if (self.recordDisable || !self.audioContext || !window.AudioContext || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            self.$toast('当前浏览器不支持录音');
            return
          }
          if (self.recorder) {
            self.recorder.record()
            self.resumeAudioContext()
          } else {
            function failed() {
              self.recordDisable = true
              self.$toast('当前浏览器不支持录音');
            }

            try {
              var value = navigator.mediaDevices.getUserMedia({
                audio: true
              }).then(stream => {
                var input
                try {
                  input = self.audioContext.createMediaStreamSource(stream)
                  self.recorder = new Recorder(input)
                  self.recorder.record()
                  self.resumeAudioContext()
                  if (!self.recorder) {
                    failed()
                  }
                } catch (e) {
                  failed()
                }
              }).catch(err => {
                self.$toast('没有权限获取麦克风');
                self.recordDisable = true
                console.log('No live audio input: ' + err, err.name + ": " + err.message)
              })
            } catch (e) {
              failed()
            }
          }
        }
      },
      runRecorderTime() {
        if (this.recorder) {
          this.recording = true
          this.recordTime = 0
          setTimeout(() => {
            // this.$recordTime = document.getElementById('recordTime')
          }, 800)
          this.recordTimeout = setTimeout(this.runRecordDuration.bind(this), 1000)
        }
      },
      resumeAudioContext() {
        if (this.audioContext && ~this.audioContext.state.indexOf('suspend')) {
          this.audioContext.resume().then(() => {
            console.log('audioContext suspend state resume')
            this.recorder.record()
            this.runRecorderTime()
          })
        } else {
          this.runRecorderTime()
        }
      },
      runRecordDuration() {
        this.recordTimeout = setTimeout(this.runRecordDuration.bind(this), 1000)
        this.recordTime++
        if (this.recordTime >= 60) {
          clearTimeout(this.recordTimeout)
          this.sendRecord()
        }
        // this.$recordTime.innerText = '00:' + (this.recordTime > 9 ? this.recordTime : '0' + this.recordTime)
      },
      sendRecordMsg() {
        if(this.isIOSweixin()){
           this.recording = false;
           this.mstopVoice();
        }else {
          setTimeout(this.sendRecord, 500);
        }
      },
      sendRecord() {
        if (this.recording) {
          clearTimeout(this.recordTimeout)
          if (this.recordTime < 2) {
            this.$toast('语音消息最短2s')
            this.cancelRecord()
            return
          }
          this.recording = false
          // this.$recordTime.innerText = '00:00'
          this.recorder.stop()
          this.recorder.exportWAV(blob => {
            this.$store.dispatch('showLoading')
            this.$store.dispatch('sendFileMsg', {
              scene: this.scene,
              to: this.to,
              type: 'audio',
              blob: blob,
              orderNo: this.orderNo,
              consultType:this.consultType,
              deptId:this.deptId,
              uploadprogress: obj => {
                console.error('文件总大小: ' + obj.total + 'bytes')
                console.error('已经上传的大小: ' + obj.loaded + 'bytes')
                console.error('上传进度: ' + obj.percentage)
                console.error('上传进度文本: ' + obj.percentageText)
                if (obj.percentage === 100) {
                  this.$store.dispatch('hideLoading')
                }
              },
              uploaderror: (error, file) => {
                console.error('上传失败',error)
              },
              uploaddone: (res, file) => {
                console.error('上传成功',res)
              }
            })
          })
          this.recorder.clear()
        }
      },
      cancelRecord() {
        if (this.recording) {
          this.recording = false;
          if(this.isIOSweixin()){
            wx.stopRecord({
              success: function (res) {
                let localId = res.localId;
                console.log('---' + localId);
              }
            });
          }else {
            clearTimeout(this.recordTimeout)
            // if (this.$recordTime) {
            //   this.$recordTime.innerText = '00:00'
            // }
            this.recorder.stop()
            this.recorder.clear()
          }
        }
      },
      watchOper() {
        this.isMore = false;
        this.msgLoaded();
      },
      showVoice() {
        this.closeBar();
        this.watchOper();
        this.voiceShow = true;
      },
      showKeyboard() {
        this.watchOper();
        this.voiceShow = false;
      },
      textFocus() {
        var self = this;
        if (this.isIOS) {
          setTimeout(function () {
            // document.body.style.height = window.innerHeight + "px";
            // document.documentElement.style.height = window.innerHeight + "px";
            window.scrollTo(0, document.body.scrollHeight);
            // window.onscroll = function(){
            //   window.scrollTo(0, document.body.scrollHeight);
            // }
          }, 500);
        }
        this.closeBar();
        this.watchOper();
      },
      textBlur() {
        var self = this;
        if (this.isIOS) {
          // window.onscroll = null;
          setTimeout(function () {
            // document.body.style.height = window.innerHeight + "px";
            // document.documentElement.style.height = window.innerHeight + "px";
            var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
            window.scrollTo(0, Math.max(scrollHeight - 1, 0));
          }, 500);
        }
      },
      sendTextMsg() {
        this.closeBar();
        if (this.invalid) {
          this.$toast(this.invalidHint)
          return
        }
        if (/^\s*$/.test(this.msgToSent)) {

          this.$toast("请不要发送空消息");
          return
        } else if (this.msgToSent.length > 800) {
          this.$toast("请不要超过800个字");
          return
        }
        this.msgToSent = this.msgToSent.trim()
        if (this.type === 'session') {
          // 如果是机器人
          if (this.isRobot) {
            this.$store.dispatch('sendRobotMsg', {
              type: 'text',
              scene: this.scene,
              to: this.to,
              robotAccid: this.to,
              // 机器人后台消息
              content: this.msgToSent,
              // 显示的文本消息
              body: this.msgToSent
            })
          } else {
            let robotAccid = ''
            let robotText = ''

            let atUsers = this.msgToSent.match(/@[^\s@$]+/g)
            if (atUsers) {
              for (let i = 0; i < atUsers.length; i++) {
                let item = atUsers[i].replace('@', '')
                if (this.robotInfosByNick[item]) {
                  robotAccid = this.robotInfosByNick[item].account
                  robotText = (this.msgToSent + '').replace(atUsers[i], '').trim()
                  break
                }
              }
            }
            if (robotAccid) {
              if (robotText) {
                this.$store.dispatch('sendRobotMsg', {
                  type: 'text',
                  scene: this.scene,
                  to: this.to,
                  robotAccid,
                  // 机器人后台消息
                  content: robotText,
                  // 显示的文本消息
                  body: this.msgToSent
                })
              } else {
                this.$store.dispatch('sendRobotMsg', {
                  type: 'welcome',
                  scene: this.scene,
                  to: this.to,
                  robotAccid,
                  // 显示的文本消息
                  body: this.msgToSent
                })
              }
            } else {
              this.$store.dispatch('sendMsg', {
                type: 'text',
                scene: this.scene,
                to: this.to,
                text: this.msgToSent,
                doctorId: cookie.get('imDoctorId'),
                orderNo: this.orderNo,
                deptId:this.deptId,
                consultType:this.consultType
              })
            }
          }
        } else if (this.type === 'chatroom') {
          let robotAccid = ''
          let robotText = ''

          let atUsers = this.msgToSent.match(/@[^\s@$]+/g)
          if (atUsers) {
            for (let i = 0; i < atUsers.length; i++) {
              let item = atUsers[i].replace('@', '')
              if (this.robotInfosByNick[item]) {
                robotAccid = this.robotInfosByNick[item].account
                robotText = (this.msgToSent + '').replace(atUsers[i], '').trim()
                break
              }
            }
          }
          if (robotAccid) {
            if (robotText) {
              this.$store.dispatch('sendChatroomRobotMsg', {
                type: 'text',
                robotAccid,
                // 机器人后台消息
                content: robotText,
                // 显示的文本消息
                body: this.msgToSent
              })
            } else {
              this.$store.dispatch('sendChatroomRobotMsg', {
                type: 'welcome',
                robotAccid,
                // 显示的文本消息
                body: this.msgToSent
              })
            }
          } else {
            this.$store.dispatch('sendChatroomMsg', {
              type: 'text',
              text: this.msgToSent
            })
          }
        }
        this.msgToSent = '';
        this.$refs.textareaElement.innerText = ""
      },
      sendFileMsg(type) {
        this.closeBar();
        if (this.invalid) {
          this.$toast(this.invalidHint)
          return
        }
        let ipt = this.$refs[type]
        if (ipt.value) {
          if (this.type === 'session') {
            this.$store.dispatch('showLoading')
            this.$store.dispatch('sendFileMsg', {
              scene: this.scene,
              to: this.to,
              fileInput: ipt,
              doctorId: cookie.get('imDoctorId'),
              orderNo: this.orderNo,
              consultType:this.consultType,
              deptId:this.deptId,
              uploadprogress: obj => {
                console.error('文件总大小: ' + obj.total + 'bytes')
                console.error('已经上传的大小: ' + obj.loaded + 'bytes')
                console.error('上传进度: ' + obj.percentage)
                console.error('上传进度文本: ' + obj.percentageText)
                if (obj.percentage === 100) {
                  this.$store.dispatch('hideLoading')
                }
              },
              uploaderror: (error, file) => {
                console.error('上传失败',error)
              },
              uploaddone: (res, file) => {
                console.error('上传成功',res)
              }
            })
          } else if (this.type === 'chatroom') {
            this.$store.dispatch('sendChatroomFileMsg', {
              fileInput: ipt
            })
          }
        }
      },
      /**
       * emoji组件回调
       */
      emojiCLick(e) {
        let val = e
        // 单击删除按钮，，删除emoji
        if (val == '[删除]') {
          let lastIndex = this.msgToSent.lastIndexOf('[')
          if (lastIndex != -1) {
            this.msgToSent = this.msgToSent.slice(0, lastIndex)
            this.$refs.textareaElement.innerText = this.msgToSent
          }
          return
        }
        if (val[0] == '[') { // emoji
          var emoji = this.msgToSent.trim() + val;
          this.msgToSent = emoji
          this.$refs.textareaElement.innerText = emoji
        } else {//大图
          this.sendBigEmoji(val)
        }
      },
      /**
       * emoji点击发送
       */
      emojiSend(e) {
        let val = this.data.inputValue
        this.sendRequest(val)
        this.emojiFlag = false
      },
      /**
       * 发送大的emoji:实际上是type=3的自定义消息
       * {"type":3,"data":{"catalog":"ajmd","chartlet":"ajmd010"}}
       */
      sendBigEmoji(val) {
        this.closeBar();
        let self = this
        let catalog = ''
        if (val[0] === 'a') {
          catalog = 'ajmd'
        } else if (val[0] === 'x') {
          catalog = 'xxy'
        } else if (val[0] === 'l') {
          catalog = 'lt'
        }
        let content = {
          type: 3,
          data: {
            catalog,
            chartlet: val
          }
        }
        this.$store.dispatch('sendMsg', {
          type: 'custom',
          scene: this.scene,
          to: this.to,
          pushContent: '[贴图表情]',
          content: content,
          doctorId: cookie.get('imDoctorId'),
          orderNo: this.orderNo,
          deptId:this.deptId,
          consultType:this.consultType,
          callback: function (err, msg) {

            // 隐藏发送栏
            self.emojiFlag = false;

            // 滚动到底部
            self.scrollToBottom()
          }
        })
      },
      endChat() {
        this.endAsk = false;
        $services.sendInstructions({
          instructionsCode: "301003",
          doctorId: this.doctorId,
          imDoctorId: this.toIm.accid
        }).then(res => {
          this.$store.dispatch('setRecordStatus', "04");
        }).catch(function (err) {
          console.log(err);
        });
      },
      continueChat(){
        $services.sendInstructions({
          instructionsCode: "301010",
          orderNo: this.orderNo
        }).then(res => {

        }).catch(function (err) {
          console.log(err);
        });
      },
      endChatAsk() {
        if (this.userType == "03") {
          this.autoTime = 600;
          $services.sendInstructions({
            instructionsCode: "302003",
            userId: this.userId,
            imUserId: this.toIm.accid,
            url: "",
            orderNo: this.orderNo
          }).then(res => {

          }).catch(function (err) {
            this.autoTime = 0;
            console.log(err);
          });
        } else {
          this.endAsk = true;
        }
      },
      cancelOrder() {
        this.cancelAsk = false;
        $services.sendInstructions({
          instructionsCode: "301002",
          doctorId: this.doctorId,
          url: "",
          userId:this.userId,
          orderNo:this.orderNo
        }).then(res => {
          this.$store.dispatch('setRecordStatus', "05");
        }).catch(function (err) {
          console.log(err);
        });
      },
      accepts() {
        $services.sendInstructions({
          instructionsCode: "302001",
          userId: this.userId
        }).then(res => {
          clearInterval(this.timer);
          this.cutTime = res.time;
          this.timeFormat();
          this.cutTimer();
          // this.$store.dispatch('setRecordStatus', "03");
        }).catch(function (err) {
          console.log(err);
        });
      },
      unAccepts() {
        $services.sendInstructions({
          instructionsCode: "302002",
          userId: this.userId,
          url: "",
          orderNo: this.orderNo
        }).then(res => {
          clearInterval(this.timer);
          // this.$store.dispatch('setRecordStatus', "05");
        }).catch(function (err) {
          console.log(err);
        });
      },
      getConsultInfo() {
        // if(this.userType == "03"){
        //   $services.getDoctorConsultInfo({
        //     serviceType:"01",
        //     userId:this.userId,
        //     consultType:""
        //   }).then(res => {
        //     this.$store.dispatch('setRecordStatus', res.record.status);
        //     this.cutTime = res.time;
        //     this.orderNo = res.record.id;
        //     this.timeFormat();
        //     if(res.record.status == "03"){
        //       this.cutTimer();
        //     }
        //     if(res.record.status == "01" || res.record.status == "02"){
        //       this.addTimer(res.timeCount);
        //     }
        //     this.toIm = JSON.parse(res.imUser.imUserExtra);
        //     //this.$store.dispatch('setRecordStatus', cookie.get("recordStatus"));
        //     this.toName = this.toIm.name;
        //     this.$store.dispatch('setCurrSession', "p2p-"+this.toIm.accid);
        //     this.loadMore();
        //   }).catch(function (err) {
        //     console.log(err);
        //   });
        // }else{
        //   $services.getInitiateConsultInfo({
        //     serviceType:"01",
        //     doctorId:this.doctorId,
        //     consultType:"",
        //     source:"1"
        //   }).then(res => {
        //     console.log(res)
        //     this.$store.dispatch('setRecordStatus', res.record.status);
        //     this.cutTime = res.time;
        //     this.orderNo = res.record.id;
        //     this.consultType = res.record.consultType;
        //     this.timeFormat();
        //     if(res.record.status == "03"){
        //       this.cutTimer();
        //     }
        //     if(res.record.status == "01" || res.record.status == "02"){
        //       this.addTimer(res.timeCount);
        //     }
        //     this.toIm = JSON.parse(res.imUser.imUserExtra);
        //     //this.$store.dispatch('setRecordStatus', cookie.get("recordStatus"));
        //     this.toName = this.toIm.name;
        //     this.$store.dispatch('setCurrSession', "p2p-"+this.toIm.accid);
        //     this.loadMore();
        //   }).catch(function (err) {
        //     console.log(err);
        //   });
        // }
        $services.getConsultInfoByOrderNo({
          orderNo: this.orderNo,
          userType: this.userType
        }).then(res => {
          this.isOnload = false;
          this.$store.dispatch('setRecordStatus', res.record.status);
          this.cutTime = res.time;
          this.autoTime = res.autoTime;
          this.endAskTime = res.timetag;
          this.orderNo = res.record.id;
          this.consultType = res.record.consultType;
          this.consultPrice = res.record.consultPrice;
          this.userId = res.record.userId;
          this.deptId = res.record.deptId;
          this.doctorId = res.record.doctorId;
          this.doctorImg = res.record.doctorImg || "";
          this.doctorSex = res.record.doctorSex || "1";
          this.userSex = res.record.userSex || "1";
          this.timeFormat();
          if (res.record.status == "03") {
            this.cutTimer();
          }
          if (res.record.status == "01" || res.record.status == "02") {
            this.addTimer(res.timeCount);
          }
          this.toIm = JSON.parse(res.imUser.imUserExtra);
          //this.$store.dispatch('setRecordStatus', cookie.get("recordStatus"));
          this.toName = this.toIm.name;
          this.$store.dispatch('setCurrSession', "p2p-" + this.toIm.accid);
          this.$store.dispatch('subscribeEvent', this.toIm.accid);
          this.$nextTick(()=>{
            this.loadMore();
          })
        }).catch(function (err) {
          console.log(err);
        });

      },
      getPlatImResourceList() {
        $services.getPlatImResourceList({
          type: this.userType == "01" ? "1" : "2"
        }).then(res => {
          this.platList = res || [];
        }).catch(function (err) {
          console.log(err);
        });
      },
      platLink(url) {
        window.location.href = url;
      },
      goDoctorInfo() {
        this.$router.push({path: "/doctorInfo", query: {staffId: this.doctorId,deptId:this.deptId}});
      },
      replay() {
        // $services.againOrder({
        //   orderNo:this.orderNo
        // }).then(res => {
        //   if(res.status == "0"){
        //     this.$router.push({ path: "/payment", query: {money: this.consultPrice,consultType: this.consultType,orderNo: res.orderNo,type: 2}});
        //   }else{
        //     this.$toast(res.msg);
        //   }
        // }).catch(function (err) {
        //   console.log(err);
        // });

        var isConsult = "";
        if(this.consultType == "03" || this.consultType == "04"){
          isConsult = 1;
        }
        this.$router.push({path: "/doctorInfo", query: {staffId: this.doctorId,sessionId:this.$store.getters.token,isConsult:isConsult,deptId:this.deptId}});
      },
      // audioNim(){
      //   let sessionId = this.currSessionId
      //   this.closeTool();
      //   this.$store.dispatch('doCalling', {
      //       type: 'audio',
      //       account: sessionId.replace("p2p-", "")
      //   })

      //   this.$router.push({ path: "/videoCall"});
      // },
      // videoNim(){
      //   let sessionId = this.currSessionId
      //   this.closeTool();
      //   this.$store.dispatch('doCalling', {
      //       type: 'video',
      //       account: sessionId.replace("p2p-", "")
      //   })

      //   this.$router.push({ path: "/videoCall"});
      // },
      audioNim() {
        navigator.getUserMedia = navigator.getUserMedia ||
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia ||
          navigator.msGetUserMedia;
        if (navigator.getUserMedia) {
          this.$store.dispatch('doCalling', {
            type: 'audio',
            account: this.currSessionId.replace("p2p-", "")
          })

          this.$router.push({path: "/netcall"});
        } else {
          this.$toast("当前浏览器不支持WebRTC功能或H264的编解码格式, 无法使用音视频功能");
        }
      },
      videoNim() {
        navigator.getUserMedia = navigator.getUserMedia ||
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia ||
          navigator.msGetUserMedia;
        if (navigator.getUserMedia) {
          this.$store.dispatch('doCalling', {
            type: 'video',
            account: this.currSessionId.replace("p2p-", "")
          })

          this.$router.push({path: "/netcall"});
        } else {
          this.$toast("当前浏览器不支持WebRTC功能或H264的编解码格式, 无法使用音视频功能");
        }
      },
      initJSSDK() {
        //初始化JS-SDK
        let agent = navigator.userAgent.toLowerCase();
        let _urlStr = window.location.href;
        if (agent.match(/MicroMessenger/i) == "micromessenger") {
          // 微信sdk
          this.$http.getWxConfig({
            url: _urlStr.split('#')[0]
          }).then(res => {
            console.error("wechatJsapiConfig:" + res);
            if (res) {
              wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.appId, // 必填，公众号的唯一标识
                timestamp: res.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.nonceStr, // 必填，生成签名的随机串
                signature: res.signature,// 必填，签名
                jsApiList: ['getLocation', 'startRecord', 'stopRecord', 'uploadVoice', 'translateVoice'] // 必填，需要使用的JS接口列表
              });
            }
          }).catch(err => {
            console.log(err)
          });
        }
      },
      mstartVoice() {
        this.recording = true;
        wx.startRecord();
      },
      mstopVoice() {
        let self = this;
        //停止录音接口回调
        wx.stopRecord({
          success: function (res) {
            var localId = res.localId;
            //上传语音
            wx.uploadVoice({
              localId: localId, // 需要上传的音频的本地ID，由stopRecord接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function (res) {
                let serverId = res.serverId; // 返回音频的服务器端ID
                self.$http.sendMyVoice({
                  media_id: serverId,
                  fromAccid: self.fromIm.accid,
                  toAccid: self.toIm.accid,
                  orderNo: self.orderNo,
                  deptId:this.deptId
                }).then(res => {
                  self.tempSendV(res);
                }).catch(err => {
                  console.log(err)
                });
              }
            });
          }
        });
      },
      tempSendV(blob) {
        let _b = blob;
        console.error("8kkkkk");
        let bS = this.base64ToBlob(_b);
        console.error(bS)
        this.$store.dispatch('showLoading')
        this.$store.dispatch('sendFileMsg', {
          scene: this.scene,
          to: this.to,
          type: 'audio',
          blob: bS,
          orderNo: this.orderNo,
          consultType:this.consultType,
          deptId:this.deptId,
          uploadprogress: obj => {
            console.log('文件总大小: ' + obj.total + 'bytes')
            console.log('已经上传的大小: ' + obj.loaded + 'bytes')
            console.log('上传进度: ' + obj.percentage)
            console.log('上传进度文本: ' + obj.percentageText)
            if (obj.percentage === 100) {
              this.$store.dispatch('hideLoading')
            }
          },
          uploaderror: () => {
            console && console.log('上传失败')
          },
          uploaddone: (error, file) => {
            console.log(error)
          }
        })
      },
      base64ToBlob(base64Data) {
        let mimeType = {type: "audio/wav"};
            base64Data = base64Data.replace(/^(.*)[,]/, '');
        let sliceSize = 1024;
        let byteCharacters = atob(base64Data);
        let bytesLength = byteCharacters.length;
        let slicesCount = Math.ceil(bytesLength / sliceSize);
        let byteArrays = new Array(slicesCount);
        for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
          let begin = sliceIndex * sliceSize;
          let end = Math.min(begin + sliceSize, bytesLength);
          let bytes = new Array(end - begin);
          for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
          }
          byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        let _blob = new Blob(byteArrays, mimeType);
        console.error("=-=-JJ=-");
        console.error(_blob)
        return _blob;
      },
      isIOSweixin(){
        //判断是否在ios微信打开
        let _userAgent = navigator.userAgent,
            _ua = _userAgent.toLowerCase();
        if(/(iPhone|iPad|iPod|iOS)/i.test(_ua) && _ua.match(/micromessenger/i) == 'micromessenger'){
          return true;
        }
        return false;
      },
      customFun(item){
        var content = item.content;
        var custom = JSON.parse(item.custom);
        if(content.orderNo == this.orderNo){
          if(content.type == "301002" && (this.recordStatus == "01" || this.recordStatus == "02")){
            this.$store.dispatch('setRecordStatus', "05");
          }
          if((content.type == "301003" || content.type == "302013") && (this.recordStatus == "03")){
            this.toolShow = false;
            this.emojiFlag = false;
            this.$store.dispatch('setRecordStatus', "04");
            if(this.userType == '01' && !this.isInitiative){
              this.evaluateAsk = true;
            }
          }
          if(content.type == "301008" && custom.isOrderEnd == true && this.recordStatus == "99"){
            this.$store.dispatch('setRecordStatus', "05");
          }
          if(content.type == "301010" && this.recordStatus == "03"){
            this.autoTime = 0;
          }
          if(content.type == "302001" && (this.recordStatus == "01" || this.recordStatus == "02")){
            clearInterval(this.timer);
            this.cutTime = custom.time;
            this.timer = null;
            this.timeFormat();
            this.cutTimer();
            this.$store.dispatch('setRecordStatus', "03");
          }
          if(content.type == "302002" && (this.recordStatus == "01" || this.recordStatus == "02")){
            this.$store.dispatch('setRecordStatus', "05");
          }
          if(content.type == "302003" && this.recordStatus == "03"){
            this.toolShow = false;
            this.emojiFlag = false;
            var thisOrderTime = this.createTime.getTime();
            if(item.time > thisOrderTime){
                this.endAskTime = item.time;
            }
            this.autoTime = 600;
          }
          if(content.type == "302004" && custom.isOrderEnd == true && this.recordStatus == "99"){
            this.toolShow = false;
            this.emojiFlag = false;
            this.$store.dispatch('setRecordStatus', "04");
          }
        }
        else{
          if((content.type == "301001" || content.type == "301004") && (this.recordStatus == "04" || this.recordStatus == "05" || this.recordStatus == "06" || this.recordStatus == "07" || this.recordStatus == "08" || this.recordStatus == "10")){
            // var thisOrderTime = new Date(this.createTime).getTime();
            var thisOrderTime = this.createTime.getTime();
            if(item.time > thisOrderTime){
                this.$router.replace({query: {userType: this.userType,orderNo:content.orderNo}});
            }
          }
        }
      },
      showFullImg (src) {
        // this.$store.dispatch('showFullscreenImg', {
        //   src
        // })
        this.images = [src]
        const viewer = this.$el.querySelector('.images').$viewer
        viewer.show()
      },
      //重新编辑
      reEdit(text){
        this.msgToSent = text;
        this.$refs.textareaElement.innerText = text;
        this.showKeyboard();
      },
      //消息撤回
      revocateMsg(msg){
        this.reMsg = msg;
        this.touchLoopShow = true;
        // this.$store.dispatch('revocateMsg', {
        //   idClient: msg.idClient
        // })
      },
      revocateMsgConfirm(){
        this.$store.dispatch('revocateMsg', {
          idClient: this.reMsg.idClient
        })
        this.touchLoopShow = false;
      },
      //更新消息状态
      updateMsg() {
        this.$http.msgUpdate({
          linkId: this.orderNo,
          status: '02'
        });
      },
      changeVal(val) {
          this.msgToSent = val.target.innerText;
          // console.log('this.inputText==>', this.inputText)
      }
    },
    destroyed() {
      this.updateMsg();
      document.body.style.height = null;
      document.documentElement.style.height = null;
      this.$store.dispatch('resetNoMoreHistoryMsgs');
      // this.$store.dispatch('hideFullscreenImg')
    }
  }
</script>
<style>
  page {
    background: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/imChat.vue